// extracted by mini-css-extract-plugin
var _1 = "FlatSearchItem-moduleFlatSearchItem__wTvEQ SearchItem-moduleSearchItem__qpbuZ";
export { _1 as "FlatSearchItem" }
